enum MailListContextMenuSource {
    MailListItem,
    MailListItemPart,
    MailListGroupHeader,
}

export default MailListContextMenuSource;
